import { UserAuthAction } from "./action";
import { JWTPayload, UserAuth, UserAuthState, userAuth } from "./state";
import jwt_decode from "jwt-decode";


export  function getDataFromToken(token:string|null):UserAuth|null{
    if (!token){
        return null
    }
    try {
        let userPayload: JWTPayload = jwt_decode(token)
        return { 
            token: userPayload,
            error: undefined
        }
    } catch (error) {
        return {
            token: undefined,
            error: "error"
        }
    }
}


export function UserAuthReducer (state:UserAuthState=userAuth,action:UserAuthAction):UserAuthState{
    switch (action.type){
        case '@@UserAuth/inputUsernameAction':
            return {
                ...state,
                username:action.username
            }
        case '@@UserAuth/inputPasswordAction':
            return {
                ...state,
                password:action.password
            }

        case '@@UserAuth/changeisAuthenticatedAction':
            return {
                ...state,
                isAuthenticated:action.isAuthenticated
            }
        case '@@UserAuth/LOGIN_FAIL':
            return {
                ...state,
                isAuthenticated:false
            }
        case '@@UserAuth/LOGIN_SUCCESS':
            return {
                ...state,
                isAuthenticated:true,
                user: getDataFromToken(action.token)

            }



        default:
            return state
    }


}